import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { selectUser } from '../state/auth/auth.selector';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AdminGuard {
  constructor(private store: Store, private router: Router) {}

  canActivate(
    pathIfNotAdmin: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getUser(pathIfNotAdmin);
  }

  canActivateChild(
    pathIfNotAdmin: string
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.getUser(pathIfNotAdmin);
  }

  private getUser(pathIfNotAdmin: string) {
    return this.store.select(selectUser).pipe(
      filter((user) => user !== null),
      map((user) => {
        if (user?.isAdmin) {
          return true;
        } else {
          this.router.navigateByUrl(pathIfNotAdmin);
          return false;
        }
      })
    );
  }
}
